import { useEffect, useMemo, useState } from "react";
import { PRODUCT_CREATE_REVIEW_RESET } from "../redux/Constants/ProductConstants";
import { arrCountry, formatNumber, payOrderCard, rateUsdt } from "../service";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import VietQRGenerator from "../lib/vietQR";

const normalizeExpiry = (v) => {
    // giữ lại tối đa 6 số, tự chèn '/'
    const raw = (v || "").replace(/[^\d]/g, "").slice(0, 4);
    if (raw.length <= 2) return raw;           // "M", "MM"
    return raw.slice(0, 2) + "/" + raw.slice(2); // "MM/YYYY"
};

export default function CardPaymentForm({ product }) {
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    // console.log(userInfo);


    const [fee, setFee] = useState(0);
    const [qty, setQty] = useState("USA");
    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        formState: { errors, isSubmitting },
    } = useForm({
        defaultValues: {
            cardName: "",
            cardNumber: "",
            experiedDate: "", // YYYY-MM (type="month")
            amountPayment: "",
            country: arrCountry[0],
        },
        mode: "onTouched",
    });




    const amountPayment = watch("amountPayment");
    const experiedDate = watch("experiedDate");
    useEffect(() => {
        handingFee();
        return () => {

        };
    }, [amountPayment, experiedDate]);
    const handingFee = () => {
        const today = new Date();
        const day = today.getDate();
        let dateas = experiedDate - day;

        let feee;
        switch (dateas) {
            case 0:
                feee = 2
                break;
            case 1:
                feee = 1.95;
                break;
            case 2:
                feee = 1.9;
                break;
            case 3:
                feee = 1.85;
                break;
            case 4:
                feee = 1.8;
                break;
            case 5:
                feee = 1.75;
                break;
            case 6:
                feee = 1.7;
                break;
            case 7:
                feee = 1.65;
                break;
            case 8:
                feee = 1.6;
                break;
            default:
                feee = 1.6;
                break;
        }
        setFee(feee);
    }



    const payment_ = async (values) => {
        let dt = await payOrderCard(
            {
                cardName: values.cardName,
                cardNumber: values.cardNumber,
                expDate: values.experiedDate,
                amount: values.amountPayment,
                qty: values.country
            }
        );
        if (dt) {
            alert('Success')
        } else {
            alert('Faild')
        }

    }
    return (
        <form onSubmit={handleSubmit(payment_)} className="w-full max-w-lg px-4 text-sm" >
            <h1 className="text-lg font-semibold mb-2">
                {product?.name}
            </h1>

            <div className="grid grid-cols-1 gap-4">
                {/* Card name */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Họ tên chủ thẻ</label>
                    <input
                        className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder=" Họ tên chủ thẻ"
                        type="text"
                        {...register("cardName", { required: "Vui lòng nhập Card name" })}
                    />
                    {errors.cardName && <p className="text-xs text-red-600 mt-1">{errors.cardName.message}</p>}
                </div>

                {/* Card number */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Dãy số trên thẻ</label>
                    <input
                        className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="Dãy số trên thẻ"
                        type="text"
                        inputMode="numeric"

                        {...register("cardNumber", {
                            required: "Vui lòng nhập Card number",
                            validate: (v) =>
                                (v?.replace(/\D/g, "").length ?? 0) >= 12 || "Số thẻ phải có ít nhất 12 chữ số",
                        })}
                    />
                    <p className="text-xs text-gray-500 mt-1">Chỉ nhập chữ số; tự nhóm 4 số.</p>
                    {errors.cardNumber && <p className="text-xs text-red-600 mt-1">{errors.cardNumber.message}</p>}
                </div>

                {/* Payment due date */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Ngày đến hạn</label>
                    <input
                        className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="Ngày đến hạn"
                        type="text"
                        inputMode="numeric"
                        maxLength={7}
                        autoComplete="cc-exp"
                        {...register("experiedDate", {
                            required: "Vui lòng nhập kỳ hạn (MM/YY)",
                            onChange: (e) => {
                                const v = normalizeExpiry(e.target.value);
                                setValue("experiedDate", v, { shouldValidate: true });
                            },
                            validate: {
                                format: (v) =>
                                    /^(0[1-9]|1[0-2])\/\d{2}$/.test(v || "") || "Định dạng phải là MM/YY",
                                // (tuỳ chọn) giới hạn năm:
                                // yearRange: (v) => {
                                //   const [, mm, yyyy] = (v || "").match(/^(0[1-9]|1[0-2])\/(\d{4})$/) || [];
                                //   if (!yyyy) return true;
                                //   const y = +yyyy;
                                //   return (y >= 2000 && y <= 2099) || "Năm phải từ 2000–2099";
                                // },
                            },
                        })}
                    />
                    {errors.experiedDate && <p className="text-xs text-red-600 mt-1">{errors.experiedDate.message}</p>}
                </div>

                {/* Bill of payment */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Số tiền thanh toán</label>
                    <input
                        className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="Số tiền thanh toán"
                        inputMode="decimal"

                        {...register("amountPayment", {
                            required: "Vui lòng nhập Số tiền thanh toán",
                            validate: (v) => {
                                const n = parseFloat(String(v).replace(/[,\s]/g, "").replace(",", "."));
                                return (Number.isFinite(n) && n > 0) || "Số tiền phải lớn hơn 0";
                            },
                        })}
                    />
                    {errors.amountPayment && <p className="text-xs text-red-600 mt-1">{errors.amountPayment.message}</p>}
                </div>

                {/* Country */}
                <div className="flex items-center justify-between">
                    <h6 className="text-sm text-gray-700">Quốc gia</h6>
                    <select
                        className="rounded-lg border border-gray-300 px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        {...register("country", { required: "Vui lòng chọn quốc gia" })}

                    >
                        {arrCountry?.map((x) => (
                            <option key={x} value={x}>
                                {x}
                            </option>
                        ))}
                    </select>
                </div>
                {errors.country && <p className="text-xs text-red-600 -mt-2">{errors.country.message}</p>}

                {/* Fee & total */}
                <div className="mt-1">
                    <p className="text-sm text-gray-700">
                        Phí: <span className="font-semibold">{formatNumber(amountPayment * fee / 100)} ({fee}%)</span>
                        {/* (<span className="font-medium">{feePercent}%</span>) */}
                    </p>
                    {/* <p className="text-sm text-gray-700">
            Tổng thanh toán: <span className="font-semibold">{formatNumber(total)}</span>
          </p> */}
                </div>

                {/* Submit */}
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className="inline-flex items-center justify-center rounded-lg bg-black text-white px-4 py-2 font-medium hover:bg-gray-900 disabled:opacity-60"
                >
                    {isSubmitting ? "Đang xử lý..." : "Chấp nhận"}
                </button>

                {amountPayment * fee / 100 > 0 ?
                    <VietQRGenerator order={{ totalPrice: (amountPayment * fee / (100 * rateUsdt)), _id: userInfo?.address }} />
                    : null}

                {/* Note */}
                <p className="text-xs text-gray-600 mt-4">
                    Lưu ý: Vui lòng liên hệ qua Zalo:{" "}0903.449.446
                </p>
            </div>
        </form>
    );
}
